import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const Novaseqp= props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={2} border="1px solid #ccc" borderRadius="4px">
      <Grid
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
          
                <br />
                <Typography component="span" variant="inherit" color="primary">
          Novaseq
                </Typography>
              </span>
            }
            subtitle= " Scalable throughput and flexibility for virtually any genome, sequencing method, and scale of the project."
           
            align="left"
            disableGutter
            titleVariant="h3"
          />
          
Application Areas

Large Whole-Genome Sequencing (human, plant, animal), Small Whole-Genome Sequencing (microbe, virus), Exome Sequencing, Targeted Gene Sequencing (amplicon, gene panel), Whole-Transcriptome Sequencing, Gene Expression Profiling with mRNA-Seq, miRNA & Small RNA Analysis, DNA-Protein Interaction Analysis, Methylation Sequencing, Shotgun Metagenomicss
          <SectionHeader 
          ctaGroup = {[
            <Button variant="contained" color="primary" size="large">
            Start now
          </Button>,
          <Button variant="outlined" color="primary" size="large">
            Learn more
          </Button>,
          ]}
          align="left"
            disableGutter
            titleVariant="h3"
            />
        </Grid>


        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://onwhicar.sirv.com/premas/main/illumina/thumb-novaseq.png"
            alt="TheFront Company"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

Novaseqp.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Novaseqp;
